import type { ImportAdapter } from '../types';
import { createZipImportAdapter } from './zip-import.adapter';

// =============================================================================
// STATS REPORT IMPORT ADAPTER
// =============================================================================

/**
 * Stats Report Import Adapter
 *
 * Handles import of stats reports from ZIP files.
 * Uses the shared ZIP import adapter factory for common functionality.
 *
 * Flow:
 * 1. User uploads a ZIP file containing stats reports
 * 2. System calls describe-file API to list available reports
 * 3. User selects which reports to import
 * 4. System imports selected reports with user_id and user_type (passed via params)
 *
 * Note: user_id and user_type are automatically added to initData via ctx.params
 * from the ImportModal component in StatsListV2.vue
 */
const baseAdapter = createZipImportAdapter({
  type: 'stats_report',
  emptyFileErrorKey: 'import.itemSelector.noStatsReportsFound',
});

export const statsReportAdapter: ImportAdapter = {
  ...baseAdapter,
  processingMode: 'immediate',
};

export default statsReportAdapter;
